import { SelectComponent } from "@/common/components";
import { Col, createStyles, Grid, Text, Title } from "@mantine/core";
import React, { useEffect } from "react";
import AddressSection from "./AddressSection";
import PaymentMethod from "./PaymentMethod";

function CartLeftSection() {
  const { classes } = useStyles();

  return (
    <Grid.Col lg={8}>
      <Col className={classes.titleSection}>
        <Title order={6}>1. GIỎ HÀNG</Title>
      </Col>
      <Col>
        <Text weight={500} size="sx">
          ĐỊA CHỈ GIAO HÀNG
        </Text>
      </Col>
      <AddressSection />
      <PaymentMethod />
    </Grid.Col>
  );
}

const useStyles = createStyles((theme) => ({
  titleSection: {
    padding: 5,
    paddingLeft: 10,
    backgroundColor: theme.colors.gray[2],
    borderRadius: 4,
    height: "fit-content",
  },
  paddingVertical: {
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  containerRow: {
    display: "flex",
    flexDirection: "row",
  },
}));

export default CartLeftSection;
